import {
  AnalyticsFilter,
  CustomerAnalytics,
  DashboardOverview,
  SalesAnalytics,
} from "../types/analytics";
import { ApiResponse } from "../types/common";
import apiClient from "./apiClient";

export const refreshAnalyticsViews = async (): Promise<ApiResponse<boolean>> => {
  const response = await apiClient.post("/admin/analytics/refresh");
  return response.data;
};

export const getDashboardOverview = async (
  filter: AnalyticsFilter
): Promise<ApiResponse<DashboardOverview>> => {
  const params = new URLSearchParams();
  params.append("period", filter.period);
  if (filter.startDate) params.append("startDate", filter.startDate);
  if (filter.endDate) params.append("endDate", filter.endDate);
  const response = await apiClient.get(
    `/admin/analytics/overview?${params.toString()}`
  );
  return response.data;
};

export const getSalesAnalytics = async (
  filter: AnalyticsFilter
): Promise<ApiResponse<SalesAnalytics>> => {
  const params = new URLSearchParams();
  params.append("period", filter.period);
  if (filter.startDate) params.append("startDate", filter.startDate);
  if (filter.endDate) params.append("endDate", filter.endDate);
  const response = await apiClient.get(
    `/admin/analytics/sales?${params.toString()}`
  );
  return response.data;
};

export const getCustomerAnalytics = async (
  filter: AnalyticsFilter
): Promise<ApiResponse<CustomerAnalytics>> => {
  const params = new URLSearchParams();
  params.append("period", filter.period);
  if (filter.startDate) params.append("startDate", filter.startDate);
  if (filter.endDate) params.append("endDate", filter.endDate);
  const response = await apiClient.get(
    `/admin/analytics/customers?${params.toString()}`
  );
  return response.data;
};
